import { handleActions } from 'redux-actions'

import * as whiteboardActions from '../actions'

const defaultValue = false

export default handleActions(
  {
    [whiteboardActions.openSwitchRecordingSourceDialog](state, action) {
      return true
    },
    [whiteboardActions.closeSwitchRecordingSourceDialog](state, action) {
      return false
    },
    [whiteboardActions.resetWhiteboardState](state, action) {
      return defaultValue
    },
  },
  defaultValue
)
